// extracted by mini-css-extract-plugin
export default {"root":"WHCIXd","toggle-button":"keAWHk","toggleButton":"keAWHk","icon":"CQ7hXv"};